import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "dashboard";
var dashboardService = {
    countDash() {
        var userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
        var param = {
            data: {
                yonetimId: userDataArtdoor["yonetimId"],
                userToken: userDataArtdoor["token"],
                firmaKodu: userDataArtdoor["firmaKodu"],
                methodName: "countDash"

            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default dashboardService

